import linuxOsIcon from 'src/svg/os-linux.svg'
import macOsIcon from 'src/svg/os-mac.svg'
import windowsOsIcon from 'src/svg/os-windows.svg'

export const cloudImageHardware: Record<
  string,
  {
    icon: string
    details: string[]
  }
> = {
  'Windows-Small': {
    icon: windowsOsIcon,
    details: ['2 Intel Xeon Cascade Lake', 'vCPU', '8 GB', '100 GB'],
  },
  'Mac-Medium': {
    icon: macOsIcon,
    details: ['6 Intel i7', 'vCPU', '15 GB', '150 GB'],
  },
  'Linux-XLarge': {
    icon: linuxOsIcon,
    details: ['16 Intel Xeon Cascade Lake', 'vCPU', '32 GB', '150 GB'],
  },
  'Linux-Large': {
    icon: linuxOsIcon,
    details: ['8 Intel Xeon Cascade Lake', 'vCPU', '16 GB', '200 GB'],
  },
  'Linux-Medium': {
    icon: linuxOsIcon,
    details: ['4 Intel Xeon Cascade Lake', 'vCPU', '8 GB', '100 GB'],
  },
  'Linux-Small': {
    icon: linuxOsIcon,
    details: ['2 Intel Xeon Cascade Lake', 'vCPU', '4 GB', '50 GB'],
  },
  'Windows-Medium': {
    icon: windowsOsIcon,
    details: ['4 Intel Xeon Cascade Lake', 'vCPU', '8 GB', '100 GB'],
  },
}

export const linkCloudImageHardwareDoc =
  'https://www.jetbrains.com/help/teamcity/cloud/supported-platforms-and-environments.html#JetBrains-Hosted+Agents'
